module.exports = __webpack_public_path__ + "static/media/player.f2ac8ecb.png";